module.exports = __webpack_public_path__ + "img/rotate-tablet.6d90f983.png";